import {
	setIssueInFocus,
	setIssueFilter,
	setProjectFilter,
	setIssueLinkTypeFilter,
	setSprintFilter,
	setGroupBy,
	setRollUp,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/actions.tsx';
import type { GroupBy } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/types.tsx';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux.tsx';
import type { DispatchProps } from './types.tsx';

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps> = (dispatch) => ({
	focusIssueLink: (issueId?: string | null) => {
		dispatch(setIssueInFocus(issueId));
	},
	setIssueFilter: (issueId) => {
		dispatch(setIssueFilter(issueId));
	},
	setProjectFilter: (projectIds) => {
		dispatch(setProjectFilter(projectIds));
	},
	setIssueLinkTypeFilter: (issueLinkTypeIds) => {
		dispatch(setIssueLinkTypeFilter(issueLinkTypeIds));
	},
	setSprintFilter: (sprintIds) => {
		dispatch(setSprintFilter(sprintIds));
	},
	setGroupBy: (groupBy: GroupBy) => {
		dispatch(setGroupBy(groupBy));
	},
	setRollUp(rollupBy: null | string, rollupHierarchyLevel: number) {
		dispatch(setRollUp(rollupBy, rollupHierarchyLevel));
	},
});

export default mapDispatchToProps;
